import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';

import { IKnmErknmFormEventInspector } from '../interfaces/IKnmErknmFormEventInspector';

export const getEventInspectorsValidate = (
  inspectors: IKnmErknmFormEventInspector[] | undefined,
  isKnmStatusTypeCompleted: boolean | undefined,
): FormErrors<IKnmErknmFormEventInspector>[] | string | undefined => {
  if ((!inspectors || !inspectors?.length) && !isKnmStatusTypeCompleted) {
    return 'Поле не может быть пустым';
  }

  return inspectors?.map(item => ({
    fullName: makeRequired('Поле не может быть пустым')(item.fullName),
  }));
};
